import { MobilePhonePaymentStoreService } from '@hb/modules/financial-obligations/mobile-phone-payment/mobile-phone-payment-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'mobile-phone-payment-amount',
    imports: [ApAmountInputComponent, CoApplicantPipe, ApContentPipe, ReactiveFormsModule, AdditionalInfoComponent, NextButtonComponent],
    templateUrl: './mobile-phone-payment-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: MobilePhonePaymentStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.MOBILE_PHONE_AMOUNT }
    ]
})
export class MobilePhonePaymentAmountComponent extends GlobalInjectComponent<MobilePhonePaymentStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(MobilePhonePaymentStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setAmount(amount));
    }
}
